<div class="no-results-found-wrapper">
  <h3 class="no-results">{{ NO_RESULTS_FOUND_TEXT }}</h3>
</div>
